<template>
    <div class="role-wrapper">
        <div class="role-container">
            <div class="content-wrapper card-wrapper">
                <commonSearch :custom="custom" @reset="clickResetBtn" @commonSearch-Click="searClick"></commonSearch>
                <log-table :tableData="tableData" :pageSize="pageSize" :pageNo="pageIndex"></log-table>
                <my-pagination :pageSize="pageSize" :pageIndex="pageIndex" :total="totalRows"
                    @currentChange="handleCurrentChange" @sizeChange="handleSizeChange"></my-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import CommonSearch from "../../base/searchCommon.vue";
import LogTable from "./logTable.vue";
import MyPagination from "@/base/my-pagination/my-pagination.vue";
import Cookies from "js-cookie";
export default {
    data() {
        return {
            isRouter: false,
            pageSize: 10,
            pageIndex: 1,
            totalRows: 0,
            custom: [
                {
                    name: vm.$t('log.actiondate') + "：",
                    activeCode: null,
                    type: "timeRange",
                    clearable: true,
                },
                {
                    name: vm.$t('log.type') + "：",
                    activeCode: null,
                    type: "select",
                    clearable: true,
                    item: [{ value: null, label: vm.$t('common.all') }]
                },
                {
                    name: vm.$t('log.content') + "：",
                    activeCode: null,
                    type: "input",
                    clearable: true,
                }
            ],
            tableData: []
        }
    },
    components: {
        CommonSearch,
        LogTable,
        MyPagination,
    },
    created() {
        let actionTypeList = JSON.parse(sessionStorage.getItem('actionTypeList') || '[]');
        this.custom[1].item.push(...actionTypeList);
    },
    mounted() {
        this._getDataList();
    },
    methods: {
        searClick(params) {
            this.pageIndex = 1;
            this._getDataList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this._getDataList();
        },
        handleSizeChange(val) {
            this.pageIndex = 1;
            this.pageSize = val;
            this._getDataList();
        },
        clickResetBtn() {
            this.pageIndex = 1;
            this._getDataList();
        },
        _getDataList() {
            let params = {
                index: this.pageIndex,
                pageSize: this.pageSize,
                actionType: this.custom[1].activeCode ? this.custom[1].activeCode : null,
                description: this.custom[2].activeCode,
                startTime: null,
                endTime: null,
            };

            let timeRange = this.custom[0].activeCode;
            if (timeRange && timeRange.length === 2) {
                let time = timeRange[0].split('/');
                let startDate = new Date(Number(time[2]), Number(time[1]) - 1, Number(time[0]), 0, 0, 0).getTime();
                time = timeRange[1].split('/');
                let endDate = new Date(Number(time[2]), Number(time[1]) - 1, Number(time[0]), 23, 59, 59).getTime();
                params.startTime = startDate;
                params.endTime = endDate;
            }
            let type = Cookies.get('type');
            this.$Http.post(type == 0 ? this.$Api.agentGetAgentLogList : this.$Api.dealerGetDealerLogList, params).then(res => {
                if (res.success) {
                    this.tableData = res.result.pageData;
                    this.totalRows = res.result.totalRows;
                }
            });
        },
    },
    watch: {
        $route(to, from) {
            if (to.name === "logList") {
                this.isRouter = true;
                this._getDataList();
            } else {
                this.isRouter = false;
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (to.name === "logList") {
                vm.isRouter = true;
            } else {
                vm.isRouter = false;
            }
        });
    }
}
</script>

<style scoped lang="scss">
.role-wrapper {
    .content-wrapper {
        position: relative;
        margin-top: 8px;

        .content-top {
            margin-bottom: 16px;
        }
    }
}
</style>